module.exports = __webpack_public_path__ + "img/pelatihan_sertifikat.525e5e32.png";